import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackwardIcon from '@mui/icons-material/ArrowBack';
import KettoBird from '../../public/images/ketto-logo-1.png';
import pmpCoinHandImage from '../../public/images/pledge-more/coin-hand.png'

//education images
import edu2 from '../../public/images/pledge-more/edu2.png'
import edu3 from '../../public/images/pledge-more/edu3.png'
import edu4 from '../../public/images/pledge-more/edu4.png'

//food and hunger images
import hun2 from '../../public/images/pledge-more/hun2.png'
import hun3 from '../../public/images/pledge-more/hun3.png'
import hun4 from '../../public/images/pledge-more/hun4.png'

// animals images
import ani2 from '../../public/images/pledge-more/ani2.png'
import ani3 from '../../public/images/pledge-more/ani3.png'
import ani4 from '../../public/images/pledge-more/ani4.png'

// medical images
import med2 from '../../public/images/pledge-more/med2.png'
import med3 from '../../public/images/pledge-more/med3.png'

// elderly images
import eld2 from '../../public/images/pledge-more/eld2.png'
import eld3 from '../../public/images/pledge-more/eld3.png'
import eld4 from '../../public/images/pledge-more/eld4.png'

// acid victims images
import av2 from '../../public/images/pledge-more/av2.png'
import av3 from '../../public/images/pledge-more/av3.png'

// women cause images
import wom2 from '../../public/images/pledge-more/wom2.png'
import wom3 from '../../public/images/pledge-more/wom3.png'
import wom4 from '../../public/images/pledge-more/wom4.png'

//widow images
import wid2 from '../../public/images/pledge-more/wid2.png'
import wid3 from '../../public/images/pledge-more/wid3.png'
import wid4 from '../../public/images/pledge-more/wid4.png'

import "./PledgeMorePage.scss"
import { UserLoginContext } from "../../../contexts/LoggedInUserContext";
import { checkFrequencyEvery, getCurrencySymbol, getPledgeAmt } from "../../../services/helperFunctions";
import { pledgeMoreSipSubscription } from "../../../redux/actions/MySip";
import EllipsisLoader from "../EllipsisLoader";
import { sendEvents } from "../../../redux/actions/Home";

//slab array creating
const options_days = [
  { label: "Impacts 2 ❤️", days: 15 },
  { label: "Impacts 3 ❤️", days: 10 },
  { label: "Impacts 4 ❤️", days: 7 },
];

const options_amount = [
  { label: "Impacts 2 ❤️", amount: 40 },
  { label: "Impacts 3 ❤️", amount: 50 },
  { label: "Impacts 4 ❤️", amount: 60 },
];

// Add an image array at the top (order matches your options)
const pmpImg = {
  education: [edu2, edu3, edu4],
  food_hunger: [hun2, hun3, hun4],
  animals: [ani2, ani3, ani4],
  medical: [med2, med3, med3],
  elderly: [eld2, eld3, eld4],
  acid_victims: [av2, av3, av3],
  women_girls: [wom2, wom3, wom4],
  widow: [wid2, wid3, wid4],
}
const PledgeMorePage = (props) => {
  //getting from customHooks
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const causeDetail = props.causeDetail || location.state?.causeDetail;
  const { campaign_cause } = causeDetail

  //destructing from props
  const { sip_cause } = causeDetail;

  //context api 
  const { latestOrder } = useContext(UserLoginContext);
  const { id, amount, currency, frequency } = latestOrder;

  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(1);
  const [days, setDays] = useState(options_days[1].days);
  const [error, setError] = useState('');
  const [newAmount, setNewAmount] = useState(options_days[1].amount)
  const [options, setOptions] = useState(options_days)

  useEffect(() => {
    getNonInrSlabs();
    if (isMobile) window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const getNonInrSlabs = () => {
    if (!currency || !amount) return;
    if (currency === "inr") return;

    const newAmount = getPledgeAmt(currency.toUpperCase(), parseInt(amount, 10));
    const slabs = getSlabs(newAmount);
    const updatedOptions = options_amount.map((item, i) => ({
      ...item,
      amount: slabs[i] ?? item.amount,
    }));
    setNewAmount(updatedOptions[1].amount)
    setOptions(updatedOptions);
  };

  const getSlabs = (newAmount) => {
    let returnArr = getSlabsControl(newAmount);
    return returnArr;
  }

  const getSlabsControl = (newAmount) => {
    const slab2 = getSlabAmt(Math.round(newAmount * 1.25), 50);
    const slab3 = getSlabAmt(slab2 * 1.25, 50);
    return [newAmount, slab2, slab3];
  }

  const getSlabAmt = (amt) => {
    return amt + (10 - (amt % 10 ? amt % 10 : 10));
  }

  //handle change pledge sip slab
  const handleOptionClick = (index) => {
    setError('');
    setActiveIndex(index);
    if (index !== null) {
      currency === "inr" ? setDays(options[index].days) : setNewAmount(options[index].amount);
    } else {
      setDays("")
    }
  };

  const handleDaysInputChange = (e) => {
    const val = Number(e.target.value);

    if (val < 7 || val > 30) {
      setError('Days must be between 7 and 30');
    } else {
      setError('');
    }

    if (e.target.value === "") {
      setDays("");
      return;
    }

    setDays(val);
  };

  const navigateToThankyouPage = () => {
    navigate('/pledge-thankyou', {state : { newAmount, newFrequency: `${days} days` }})
  }

  let imageSrc;
  if (activeIndex !== null && activeIndex >= 0) {
    imageSrc = pmpImg[campaign_cause][activeIndex];
  } else {
    imageSrc = pmpImg[campaign_cause][pmpImg[campaign_cause].length - 1]
  }

  const handleAmountInputChange = (e) => {
    const inputValue = e.target.value;
    const val = Number(inputValue);
    setError("");
    if (val <= amount) {
      setError(
        `Please enter a value greater than ${getCurrencySymbol(currency)}${amount}`
      );
    }
    if (inputValue === "") {
      setNewAmount("");
      return;
    }
    setNewAmount(val);
  };

  const handlePledgeMore = async () => {
    let info_2 = newAmount;

    if(currency && currency.toLowerCase() ==="inr"){
      info_2 = `${frequency}, ${days} days`;
    }

    // Event for clicking the btn
    sendEvents(
      'pledge_button_clicked',
      'pledge-more-page',
      `${id},${amount}`,
      'impact',
      info_2,
      false,
      campaign_cause,
    )

    const Inrpayload = {
      amount,
      currency: currency.toUpperCase(),
      frequency_term: 'days',
      frequency: days
    };

    const NonInrPayload = {
      amount: newAmount,
      currency: currency.toUpperCase(),
    };

    const payload = currency === "inr" ? Inrpayload : NonInrPayload;

    setIsLoading(true);

    try {
      const res = await pledgeMoreSipSubscription(id, payload);
      if (res.error) return;
      // Event For Successfull Increase Pledge
      let info_2 = `1,${id},${amount},${newAmount}`;
      if(currency && currency.toLowerCase() ==="inr"){
        info_2 = `1,${id},${amount}_${frequency},${days} days`
      }
      sendEvents(
        'pledge_increased_card',
        'pledge-more-page',
        ``,
        'impact',
        info_2,
        false,
        campaign_cause,
      )
      navigateToThankyouPage();
    } catch (error) {
      console.error("Error in pledgeMoreSipSubscription", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackCTA = ()=>{
    if (latestOrder?.campaign_cause) {
      navigate(`/${latestOrder.campaign_cause}`);
    } else {
      navigate('/sipselect');
    }
  }

  return (
    <>
      {isLoading && <div className='component-loader'><EllipsisLoader /></div>}
      <div className="pmp-wrapper">
        {isMobile &&
          <div className="pmp-back" onClick={handleBackCTA} >
            <ArrowBackwardIcon className='mfs-20 back-btn' /> Back
          </div>
        }
        {/* Top Section */}
        <div className="pmp-top">
          <img src={KettoBird} alt="ketto-bird" className="ketto_bird-1" />
          <img src={KettoBird} alt="ketto-bird" className="ketto_bird-2" />
          <div className="pmp-image-highlight-0"></div>
          <svg className="pmp-image-highlight-1" xmlns="http://www.w3.org/2000/svg" width="304" height="223" viewBox="0 0 304 223" fill="none">
            <g opacity="0.5" filter="url(#filter0_f_2280_8797)">
              <ellipse cx="124.326" cy="173.5" rx="99.3261" ry="93.5" fill="#DDF6F7" fillOpacity="0.4" />
            </g>
            <defs>
              <filter id="filter0_f_2280_8797" x="-55" y="0" width="358.652" height="347" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur_2280_8797" />
              </filter>
            </defs>
          </svg>
          <svg className="pmp-image-highlight-2" xmlns="http://www.w3.org/2000/svg" width="311" height="198" viewBox="0 0 311 198" fill="none">
            <g opacity="0.5" filter="url(#filter0_f_2280_8798)">
              <ellipse cx="179.432" cy="173" rx="99.3261" ry="93" fill="#DDF6F7" fillOpacity="0.4" />
            </g>
            <defs>
              <filter id="filter0_f_2280_8798" x="0.105469" y="0" width="358.652" height="346" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="40" result="effect1_foregroundBlur_2280_8798" />
              </filter>
            </defs>
          </svg>
          <div className="pmp-header">
            <p className="pmp-title">Donate more to {sip_cause?.info_2} SIP</p>
            <p className="pmp-subtitle">
              Create a bigger impact with frequent donations
            </p>

          </div>
          <div className="pmp-image-container">
            <img
              key={imageSrc}
              src={imageSrc}
              alt={`${campaign_cause} image`}
              className="pmp-image fade-in"
            />
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pmp-bottom">
          <div className="pmp-content">
            <div className="pmp-title-wrapper">
              <p className="pmp-content-title">Choose your new frequency:</p>
              <div className="pmp-current">
                <span>Currently, you contribute:  <strong>{getCurrencySymbol(currency)}{amount} {checkFrequencyEvery(frequency) ? checkFrequencyEvery(frequency) : " / mo"}</strong></span>
                <img src={pmpCoinHandImage} className="pmp-hand-icon-img" alt="pmp-hand-icon" />
              </div>
            </div>
            <div className="pmp-options-container">
              <div className="pmp-options">
                {options.map((opt, index) => (
                  <div
                    key={index}
                    className={`pmp-option ${activeIndex === index ? "active" : ""}`}
                    onClick={() => handleOptionClick(index)}
                  >
                    <div className="pmp-label">{opt.label}</div>
                    {currency === "inr" ? <div className="pmp-days">{opt.days} days</div> : <div className="pmp-days">{getCurrencySymbol(currency)}{opt.amount} <br /> <span className="sub-label">per month</span></div>}
                  </div>
                ))}
              </div>

              {/* Other Amount or Days */}
              {activeIndex !== null && (
                <div className="pmp-other-option">
                  <div
                    className={`pmp-option`}
                    onClick={() => handleOptionClick(null)}
                  >
                    <div className="pmp-label">Other</div>
                  </div>
                </div>
              )}

              {/* Input for INR (Days Change)   */}
              {activeIndex === null && currency && currency.toLowerCase() === "inr" && (
                <div className="pmp-other-input">
                  <div className={`pmp-input-wrapper ${error ? "error" : ""}`}>
                    <span className="pmp-label">Days</span>
                    <input
                      type="number"
                      min="7"
                      max="30"
                      value={days}
                      onChange={handleDaysInputChange}
                      placeholder="Enter days"
                    />
                  </div>
                  {error && <p className="pmp-error">{error}</p>}
                </div>
              )}

              {/* Input for NON-INR (Amount Change)   */}
              {activeIndex === null && currency && currency.toLowerCase() !== "inr" && (
                <div className="pmp-other-input">
                  <div className={`pmp-input-wrapper ${error ? "error" : ""}`}>
                    <span className="pmp-label">{getCurrencySymbol(currency)}</span>
                    <input
                      type="number"
                      min={amount+1}
                      value={newAmount}
                      onChange={handleAmountInputChange}
                      placeholder="Enter Amount"
                    />
                  </div>
                  {error && <p className="pmp-error">{error}</p>}
                </div>
              )}

            </div>
          </div>
          {/* Button for INR */}
          {(currency && currency.toLowerCase() === "inr") && (
            <div className="pmp-button-section">
              <button
                onClick={handlePledgeMore}
                disabled={error || !days}
                className={error || !days ? "disabled" : ""}
              >Contribute {getCurrencySymbol(currency)}{amount}/{days} days <ArrowForwardIcon className="arrow-icon mfs-16" /></button>
            </div>
          )}
          {/* Button for NON-INR */}
          {(currency && currency.toLowerCase() !== "inr") && (
            <div className="pmp-button-section">
              <button
                onClick={handlePledgeMore}
                disabled={error || !newAmount}
                className={error || !newAmount ? "disabled" : ""}
              >Pledge {getCurrencySymbol(currency)}{newAmount} / Month <ArrowForwardIcon className="arrow-icon mfs-16" /></button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default PledgeMorePage;